export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sort.vue?vue&type=template&id=4505c0a4&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/sort/sort.vue?vue&type=template&id=4505c0a4&
// module id = 1491
// module chunks = 0